/* eslint-disable jira/filename-case */
import { installGlobalHandler as installSentryGlobalHandler } from './sentry-browser.tsx';

// IE11 error with new sentry browser sdk - https://jdog.jira-dev.com/browse/JFP-2406
// remove when IE11 is deprecated and switch to new sentry client
export const installGlobalHandler = (): 'sentry-init' | undefined =>
	__SERVER__ ? undefined : installSentryGlobalHandler();
